import { render, staticRenderFns } from "./PropertyCalendarContentTest.vue?vue&type=template&id=3b1301cd&scoped=true&"
import script from "./PropertyCalendarContentTest.vue?vue&type=script&lang=js&"
export * from "./PropertyCalendarContentTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1301cd",
  null
  
)

export default component.exports